import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { noop } from 'rxjs';

const dsn = environment.sentry.dsn;
if (environment.isProd) {
  // disable console logging in production
  window.console.log = () => noop();

  if (dsn) {
    Sentry.init({
      environment: 'production',
      dsn,
    });
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
